import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles({
  address: {
    display: 'flex',
    justifyContent: 'space-between',
    '&  .MuiIcon-root': {
      fontSize: '42px'
    }
  },
  storeName: {
    fontWeight: 'bold'
  }
});

export default ({pickupLocation}) => {
  const classes = useStyles();

  return <div>
  <Box className={classes.address}>
    <div>
      <div className={classes.storeName}><b>{pickupLocation.description}</b></div>
      <div>{pickupLocation.pickupaddress1}</div>
      <div>{pickupLocation.pickupaddress2}</div>
      <div>{pickupLocation.pickuppostalcode} {pickupLocation.pickupcity}</div>
    </div>
    <div>
      <Icon>place</Icon>
    </div>
  </Box>
    {/*
    <div>
      <h4>Åpningstider</h4>

    </div>
    */}
  </div>
}